/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setShowModal } from "src/redux/features/charts/modalSlice";

/* Ionic */
import { flash } from "ionicons/icons";

/* Utils */
import { getFilterToolbarItems } from "src/components/insights/filter-toolbar/getFilterToolbarItems";

/* Components */
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";

/* Constants */
import { ModalType } from "src/shared/constants/common/Modal";

/* Stylesheet */
import styles from "./FilterToolbar.module.scss";

const FilterToolbar: React.FC = () => {
  const dispatch = useDispatch();

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const insightsFilterState = useSelector(
    (state: RootState) => state.insightsFilter
  );

  const featureTypesState = useSelector(
    (state: RootState) => state.featureTypes
  );

  const { isLoading } = featureTypesState;

  return (
    <div className={styles.filter_toolbar}>
      {getFilterToolbarItems(
        insightsFilterState,
        customCohortsState
      ).map((item, index) => {
        const { component: Component } = item;
        return item.show ? (
          <Component key={index} {...item} />
        ) : undefined;
      })}
      <PrimaryButton
        scssProps={{
          marginLeft: "auto",
          height: "42px",
        }}
        icon={flash}
        type={"button"}
        label={"Custom Cohorts"}
        ariaLabel={"Custom Cohorts"}
        disabled={isLoading}
        onClick={() =>
          dispatch(
            setShowModal({
              modalType: ModalType.CUSTOM_COHORTS,
              showModal: true,
              className: "custom_cohorts",
            })
          )
        }
      />
    </div>
  );
};

export default FilterToolbar;
